import React from 'react';
import { Text, View } from "../../Components/Themed";
import type { TextTagProps } from '../../types';
import TagRenderer from './components/TagRenderer';
import { useColors } from '../../constants/useColors';

type FormattedTextProps = {   
    text: string,
    tags:TextTagProps[],
    text_color?:string,
    onSelectTag: (tag:TextTagProps) => void
} 



export const FormattedText = ({ text, tags, text_color, onSelectTag }:FormattedTextProps) => {
    const components = formatText(text, tags, onSelectTag, text_color);
    let unique_lines = [ ...new Set(components.map(c => c.line)) ];
 
    return (
        <View transparent>
            {unique_lines.map(l => {
                let render_components = components.filter(c => c.line == l)
                return (
                    <View key={l.toString()} transparent type='row' style={{ flexWrap:'wrap' }}>
                        {render_components.map(c => c.component)}
                    </View>
                )
            })}
        </View>
    )
}

export const splitText = (text:string) => {
    return text.split(' ');
}



export const formatText = (text:string, included_tags:TextTagProps[], onSelectTag:(tag:TextTagProps) => void, text_color?:string):{ line:number, component:any }[] => {
    const Colors = useColors();
    let raw_text = text.replace(/\\n/g, " {ln} ")
    let parsed_text:string[] = JSON.parse(raw_text as string).split(' ');
    //First - lets grab the line breaks
    let line_breaks:number[] = []
    parsed_text.map((t,i) => {
        let breaks = t.split('{ln}');
        if(breaks.length > 1){
            line_breaks.push(i);
        }
    })

    let components:{line:number, component:any}[] = []
    let lines:{ [key:number]: string } = {}
    let tags:{ [key:number]: string[] } = {}
    //Second - Lets generate the lines and grab tags out of the lines
    let curr_line = 0
    parsed_text.map((t,i) => {
        let line_break = line_breaks.find(b => b == i)
        if(line_break){ curr_line += 1; return }
        let curr_string = lines[curr_line] ?? ''
        curr_string += `${t} `
        lines[curr_line] = curr_string
        let tag = t.split('@');
        if(tag.length == 2){
            let curr_tags = tags[curr_line] ?? []
            tags[curr_line] = curr_tags.concat(t)
        }
    });
    Object.values(lines).map((l,i) => {
        let split_line = splitText(l);
        split_line.map((sl) => {
            let tag = included_tags.find(t => `${t.indicator}${t.tag}` == sl);
            if(tag){
                return components.push({
                    line: i,
                    component: <TagRenderer tag={tag} data={tag?.data} onPress={onSelectTag}/>
                })
            }
            return components.push({
                line: i,
                component: <Text theme='description' color={text_color ?? Colors.text.h1}>{sl} </Text>
            })
        })
    })
    return components
}